import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getSingleProductbystatus } from "../../../actions/singleProductAction";
import { getAllCategory } from "../../../actions/categoryAction";
import RenderTable from "./RenderTable";
import ActiveRenderTable from "./ActiveRendertable";
import {
  Skeleton,
  Tabs,
  Row,
  Col,
  AutoComplete,
  Divider,
  TreeSelect,
  Spin,
  Checkbox,
  Space,
  DatePicker,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const ProductList = ({
  getSingleProductbystatus,
  List,
  updatelist,
  setUpdatelist,
  setselectedproduct,
  totalitems,
  getAllCategory,
  categoryList,
}) => {
  const [data, setdata] = useState(false);
  const [products, setproducts] = useState(false);
  const loading = useRef(true);
  const pageno = useRef(1);
  const page_size = useRef(10);
  const keytab = useRef(true);
  const keyward = useRef("");
  const searchCategory = useRef("");
  const [reload, setreload] = useState(false);
  const searchProductDiscount = useRef("");
  const searchIsEcommerce = useRef("");
  const searchStockOut = useRef("");
  const searchStartDate = useRef("");
  const searchEndDate = useRef("");

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(true);
    }
  };

  function callback(key) {
    console.log(key);
    pageno.current = 1;
    if (key == 1) {
      keytab.current = true;
    } else {
      keytab.current = false;
    }
    setreload(true);
  }

  useEffect(() => {
    getAllCategory();
    getSingleProductbystatus(
      keytab.current,
      keyward.current,
      searchCategory.current,
      "",
      "",
      pageno.current,
      page_size.current,
      searchProductDiscount.current,
      searchIsEcommerce.current, 
      searchStockOut.current,
      searchStartDate.current,
      searchEndDate.current
    ).then((result) => {
      setproducts(result);
      setUpdatelist(true);
      setdata(true);
      setreload(false);
    });
  }, [reload]);

  const onEcommerceChange = (e) => {
    if (e.target.checked) {
      searchIsEcommerce.current = true;
    } else {
      searchIsEcommerce.current = "";
    }
    setreload(true);
  };

  const onStockOutChange = (e) => {
    if (e.target.checked) {
      searchStockOut.current = true;
    } else {
      searchStockOut.current = "";
    }
    setreload(true);
  };

  const onProductDiscountChange = (e) => { 
    if (e.target.checked) {
      searchProductDiscount.current = 0;
    } else {
      searchProductDiscount.current = "";
    }
    setreload(true);
  };

  const rendertable = () => {
    if (reload) {
      return (
        <>
          <span style={{ marginTop: "30px" }}>
            <Spin indicator={antIcon} /> loading
          </span>
        </>
      );
    }
  };

  if (data) {
    return (
      <>
        <Row>
          <Col span={4}>
            <h3>Enter product for Search</h3>
            <AutoComplete
              placeholder="input search text"
              onKeyUp={onChange}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={6}>
            <h3>Category</h3>

            <TreeSelect
              style={{ width: "100%" }}
              treeData={categoryList}
              onChange={(value) => {
                pageno.current = 1;
                searchCategory.current = value;
                setreload(true);
              }}
            />
          </Col>
          <Col span={8} offset={1}>
            <Row style={{ color: "white" }}>
              .
            </Row>
            <Row style={{ color: "white" }}>
              .
            </Row>

            <Row>
              {/* <Space direction="vertical">
                <Checkbox  onChange={onProductDiscountChange} >
                  <h3>Show Discounted Products</h3>
                </Checkbox>
              </Space> */}
              <Space direction="vertical">
                <Checkbox onChange={onEcommerceChange}> 
                  <h3>Show E-commerce Products </h3>
                </Checkbox>
              </Space>
              <Space direction="vertical">
                <Checkbox onChange={onStockOutChange}> 
                  <h3 style={{color:"red"}}>Stock Out</h3>
                </Checkbox>
              </Space>
            </Row>
          </Col>
          <Col span={5}>
            <Row style={{ marginTop: "10px" }}>
              <h3>Filter by Creation Date</h3>
              <RangePicker
                onChange={(dates, dateStrings) => {
                  searchStartDate.current = dateStrings[0];
                  searchEndDate.current = dateStrings[1];
                  pageno.current = 1;
                  setreload(true);
                }}
              />
            </Row>


          </Col>
          {/* <Col offset={1}>{rendertable()}</Col> */}
        </Row>
        <Divider />
        <Spin spinning={reload}>
          <Tabs defaultActiveKey="1" onChange={callback}>
            <TabPane tab="Active Products" key="1">
              <ActiveRenderTable
                List={products.results}
                setUpdatelist={setUpdatelist}
                setselectedproduct={setselectedproduct}
                pageno={pageno}
                page_size={page_size}
                totalitems={totalitems}
                setreload={setreload}
              />
            </TabPane>
            <TabPane tab="Inactive Products" key="2">
              <RenderTable
                List={products.results}
                setUpdatelist={setUpdatelist}
                setselectedproduct={setselectedproduct}
                pageno={pageno}
                page_size={page_size}
                totalitems={totalitems}
                setreload={setreload}
              />
            </TabPane>
          </Tabs>
        </Spin>
      </>
    );
  } else {
    return (
      <>
        <Skeleton active />
        <Skeleton active />
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    List: state.singleProduct.sinleproductlist.results,
    totalitems: state.singleProduct.sinleproductlist.count,
    categoryList: state.category.categorylist,
  };
};

export default connect(mapStateToProps, {
  getSingleProductbystatus,
  getAllCategory,
})(ProductList);
